<!--
  Author: Gary Hammock
  Version: 0.1.0
  Description: A renderer for credentials on Vue pages.
-->

<template>
  <div class="credential-container">
    <img
      v-if="imgSrc"
      :src="imgSrc"
      :alt="`${providerName} logo`"
      :title="`${providerName} logo`"
      class="credential-img"
    >
    <div class="credential-provider-details">
      <div class="credential-provider-name">
        {{ providerName }}
      </div>
      <div class="credential-name">
        <span v-if="credentialUrl">
          <a
            :href="credentialUrl"
            rel="nofollow"
            target="_blank"
            title="credential provider link"
          >
            {{ credentialName }}
          </a>
        </span>
        <span v-else>
          {{ credentialName }}
        </span>
        <span
          v-if="credentialId"
          class="credential-id"
        >
          — (ID:
          <span v-if="verificationUrl">
            <a
              :href="verificationUrl"
              rel="nofollow"
              target="_blank"
              title="verify this credential"
            >{{ credentialId }}</a>)
          </span>
          <span v-else>
            {{ credentialId }})
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CredentialRenderer',

  props: {
    /**
     * The name of the credential provider.
     */
    providerName: {
      type: String,
      required: true
    },

    /**
     * The name of the credential.
     */
    credentialName: {
      type: String,
      required: true
    },

    /**
     * (Optional) The path to an image to represent the credential.
     */
    imgSrc: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * (Optional) A URL to information about the provider or credential.
     */
    credentialUrl: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * (Optional) The ID or certificate number of the credential.
     */
    credentialId: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * (Optional) The URL of a certificate verification site.
     */
    verificationUrl: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style scoped>
.credential-container {
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  padding: 15px;
  max-width: 100%;
}

.credential-img {
  flex: 0 0 96px;
  align-self: center;
  min-width: 32px;
  max-width: 96px;
  margin-right: 1rem;
  padding-right: 0.5rem;
  text-align: center;
  border-right: 1px solid rgba(32, 32, 32, 0.85);
}

.credential-provider-details {
  align-self: center;
}

.credential-id {
  font-size: 90%;
}
</style>
